<template>
  <div>
    <div class="container" v-if="!sent">
      <section class="jumbotron text-center">
        <div class="container">
          <h1 class="jumbotron-heading">Recommend a Film</h1>
        </div>
      </section>
      <form class="padding-bottom-15" @submit.prevent="send">
        <div class="form-group">
          <textarea
            rows="8"
            maxlength="200"
            placeholder="Kindly share title and year :)"
            class="form-control"
            v-model="message"
          ></textarea>
        </div>
        <button type="submit" class="a btn2 btn-light">
          <div class="spinner-border" role="status" v-if="sending">
            <span>{{ spaceSeparator }}</span>
          </div>Send to Houqi
        </button>
      </form>
    </div>
    <div class="container" v-if="sent">
      <section class="jumbotron text-center">
        <div class="container">
          <p class="lead text-muted notification" style="font-size:xx-large">Sent.</p>
        </div>
      </section>
      <div>
        <a
          href="#/recommend-a-film"
          aria-current="page"
          class="nav-link text-muted btn2 btn-light router-link-exact-active router-link-active"
          @click="goBack"
        >
          <span>Go Back</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'recommend-a-film',
  data() {
    return {
      message: '',
      sending: false,
      sent: false,
      spaceSeparator: " "
    };
  },
  methods: {
    send() {
      if (this.message != '') {
        this.sending = true;
        axios
          .post(
            'https://y37cq5ugci.execute-api.us-east-1.amazonaws.com/beta/tell-hoouqi-anything/?message=' +
              this.message
          )
          .then(response => {
            this.sending = false;
            this.sent = true;
            this.message = '';  // Clear message
          })
          .catch(error => {
            this.sending = true;
            this.sent = false;
          });
      }
    },
    goBack() {
      this.sent = false;
    }
  }
};
</script>
